/**
 * Angular imports.
 */
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports.
 */
import { PipesModule } from './../../pipes/pipes.module';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConfirmModalModule } from './../../common/confirm-modal/confirm-modal.module';
import { CustomTooltipModule } from './../../common/custom-tooltip/custom-tooltip.module';
import { UserProfilePicModule } from './../../common/user-pofile-pic/user-profile-pic.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DirectivesModule } from './../../directives/directives.module';
import { MediaModalModule } from '../../common/media-modal/media-modal.module';
import { ContentCardModule } from '../../common/content-card/content-card.module';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WebinarCardModule } from '../../webinar/webinar-list/webinar-section/webinar-card/webinar-card.module';
import { FeedCardModule } from './../feed-card/feed-card.module';
import { WebDoctalkCardModule } from '../../web-doctalk/web-doctalk-list/web-doctalk-section/web-doctalk-card/web-doctalk-card.module';
import { ClinicalResourceCardModule } from 'src/app/clinical-resource/clinical-resource-card/clinical-resource-card.module';


/**
 * Component imports.
 */
import { PostingComponent } from './posting.component';
import { CreatePostComponent } from './create-post/create-post.component';
import { PostingMediaModalComponent } from './posting-media-modal/posting-media-modal.component';
import { CanvasImageEditorComponent } from '../../common/canvas-image-editor/canvas-image-editor.component';
import { TagConnectionComponent } from './tag-connection/tag-connection.component';
import { PostTypeComponent } from './post-type/post-type.component';
import { PostDraftComponent } from './post-draft/post-draft.component';
import { PostAssociationComponent } from './post-association/post-association.component';
import { SuggestionTagCardComponent } from './suggestion-tag-card/suggestion-tag-card.component';
import { AnalyticsEventModule } from '../../analytics-event/analytics-event.module';
import { PostCommunityComponent } from './post-community/post-community.component';
import { FilterTopicComponent } from './filter-topic/filter-topic.component';



@NgModule({
  declarations: [
    PostingComponent,
    CreatePostComponent,
    PostingMediaModalComponent,
    CanvasImageEditorComponent,
    TagConnectionComponent,
    PostTypeComponent,
    PostDraftComponent,
    PostAssociationComponent,
    SuggestionTagCardComponent,
    PostCommunityComponent,
    FilterTopicComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    ModalModule,
    UserProfilePicModule,
    CustomTooltipModule,
    ConfirmModalModule,
    MediaModalModule,
    InfiniteScrollModule,
    PerfectScrollbarModule,
    FilterPipeModule,
    ContentCardModule,
    PipesModule,
    NgbModalModule,
    NgbModule,
    AnalyticsEventModule,
    WebinarCardModule,
    FeedCardModule,
    WebDoctalkCardModule,
    ClinicalResourceCardModule
  ],
  exports: [
    PostingComponent,
    CreatePostComponent,
    PostingMediaModalComponent,
    CanvasImageEditorComponent,
    SuggestionTagCardComponent,
    TagConnectionComponent,
    FilterTopicComponent
  ]
})
export class PostingModule { }
